(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67010],{

/***/ 26033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Breadcrumbs/styles.module.scss
var styles_module = __webpack_require__(51701);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/utils/useBreadcrumbs.js



/* harmony default export */ function useBreadcrumbs(param) {
    var className = param.className, _breadcrumbs = param.breadcrumbs, breadcrumbs = _breadcrumbs === void 0 ? [] : _breadcrumbs, dark = param.dark;
    var classNames = classnames_default()((styles_module_default()).breadcrumbs, className, (0,_define_property/* default */.Z)({}, (styles_module_default()).dark, dark));
    return {
        className: classNames,
        breadcrumbs: breadcrumbs
    };
};

;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/index.jsx











var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Breadcrumbs = function(props) {
    var ref = useBreadcrumbs(props), breadcrumbs = ref.breadcrumbs, className = ref.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        "aria-label": "breadcrumbs",
        className: className,
        children: breadcrumbs.map(function(param, i) {
            var to = param.to, title = param.title;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50 * i,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                        path: to,
                        className: classnames_default()((styles_module_default()).item, (0,_define_property/* default */.Z)({}, (styles_module_default()).activeItem, i === breadcrumbs.length - 1)),
                        children: title
                    })
                }))
            }, to);
        })
    });
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().instanceOf(Array).isRequired,
    className: (prop_types_default()).string,
    dark: (prop_types_default()).bool
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 2610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26033);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42222);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);











var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var PageHeader = function(param) {
    var title = param.title, breadcrumbs = param.breadcrumbs, titleStyles = param.titleStyles, breadcrumbsStyles = param.breadcrumbsStyles, breadcrumbsTheme = param.breadcrumbsTheme, updatedAt = param.updatedAt, type = param.type, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                breadcrumbs: breadcrumbs,
                className: breadcrumbsStyles,
                type: type,
                dark: breadcrumbsTheme === "dark"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().titleContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, titleStyles, titleStyles), className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                    children: [
                        updatedAt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().updatedAt),
                            children: "Last updated: ".concat((0,utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .formatDate */ .p6)(updatedAt))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: title
                        }),
                        children
                    ]
                }))
            })
        ]
    });
};
PageHeader.defaultProps = {
    title: "",
    breadcrumbs: null,
    titleStyles: "",
    breadcrumbsStyles: ""
};
PageHeader.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbs: prop_types__WEBPACK_IMPORTED_MODULE_10___default().instanceOf(Array),
    titleStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbsStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 70731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SwiperNavButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./UI/components/SwiperNavButton/utils/useSwiperNavButton.js



var useSwiperNavButton = function(_param) {
    var buttonRef = _param.buttonRef, type = _param.type, text = _param.text, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonRef",
        "type",
        "text",
        "className"
    ]);
    var svgType = type === "next" ? "arrowRight" : "arrowLeft";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        buttonRef: buttonRef,
        type: type,
        text: text,
        svgType: svgType,
        className: className
    });
};

// EXTERNAL MODULE: ./UI/components/SwiperNavButton/styles.module.scss
var styles_module = __webpack_require__(5713);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SwiperNavButton/index.jsx









var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var SwiperNavButton = function(props) {
    var _ref = useSwiperNavButton(props), buttonRef = _ref.buttonRef, type = _ref.type, text = _ref.text, svgType = _ref.svgType, className = _ref.className, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "buttonRef",
        "type",
        "text",
        "svgType",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        className: classnames_default()(className, (styles_module_default()).navButton, (styles_module_default())[type]),
        ref: buttonRef,
        "data-swiper-button": true
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                type: svgType
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).text,
                children: text
            })
        ]
    }));
};
SwiperNavButton.defaultProps = {
    className: "",
    text: ""
};
SwiperNavButton.propTypes = {
    type: prop_types_default().oneOf([
        "next",
        "prev"
    ]).isRequired,
    text: (prop_types_default()).string,
    className: (prop_types_default()).string
};
/* harmony default export */ var components_SwiperNavButton = (SwiperNavButton);


/***/ }),

/***/ 33051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_CustomSwiper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/SwiperNavButton/index.jsx + 1 modules
var SwiperNavButton = __webpack_require__(70731);
// EXTERNAL MODULE: ./UI/components/SwiperNavigation/styles.module.scss
var styles_module = __webpack_require__(35133);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SwiperNavigation/index.jsx





var SwiperNavigation = function(param) {
    var className = param.className, navigationPrevRef = param.navigationPrevRef, navigationNextRef = param.navigationNextRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className, (styles_module_default()).navigationContainer),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavButton/* default */.Z, {
                type: "prev",
                text: "previous",
                buttonRef: navigationPrevRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavButton/* default */.Z, {
                type: "next",
                text: "next",
                buttonRef: navigationNextRef
            })
        ]
    });
};
SwiperNavigation.defaultProps = {
    className: null
};
SwiperNavigation.propTypes = {
    className: (prop_types_default()).string
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./UI/containers/CustomSwiper/utils/useCustomSwiper.js

var useCustomSwiper = function(param) {
    var children = param.children, swiperParams = param.swiperParams, isShowNavigation = param.isShowNavigation, navigationClassName = param.navigationClassName, className = param.className;
    var navigationPrevRef = (0,react.useRef)(null);
    var navigationNextRef = (0,react.useRef)(null);
    var onSwiperInit = function(swiper) {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
        swiper.navigation.init();
        swiper.navigation.update();
    };
    return {
        children: children,
        swiperParams: swiperParams,
        isShowNavigation: isShowNavigation,
        navigationClassName: navigationClassName,
        className: className,
        navigationPrevRef: navigationPrevRef,
        navigationNextRef: navigationNextRef,
        onSwiperInit: onSwiperInit
    };
};

;// CONCATENATED MODULE: ./UI/containers/CustomSwiper/index.jsx









var CustomSwiper = function(props) {
    var ref = useCustomSwiper(props), children = ref.children, swiperParams = ref.swiperParams, isShowNavigation = ref.isShowNavigation, navigationClassName = ref.navigationClassName, className = ref.className, navigationNextRef = ref.navigationNextRef, navigationPrevRef = ref.navigationPrevRef, onSwiperInit = ref.onSwiperInit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swiperParams), {
        onInit: isShowNavigation ? onSwiperInit : undefined,
        modules: (0,_to_consumable_array/* default */.Z)(swiperParams.modules || []).concat([
            swiper_esm/* Navigation */.W_, 
        ]),
        className: className,
        children: [
            children,
            isShowNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavigation, {
                className: navigationClassName,
                navigationPrevRef: navigationPrevRef,
                navigationNextRef: navigationNextRef
            })
        ]
    }));
};
SwiperNavigation.defaultProps = {
    isShowNavigation: false,
    navigationClassName: null
};
SwiperNavigation.propTypes = {
    isShowNavigation: (prop_types_default()).bool,
    navigationClassName: (prop_types_default()).string,
    swiperParams: prop_types_default().instanceOf(Object),
    children: prop_types_default().arrayOf((prop_types_default()).node)
};
/* harmony default export */ var containers_CustomSwiper = (CustomSwiper);


/***/ }),

/***/ 67010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Blog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./UI/components/Paginator/index.jsx + 1 modules
var Paginator = __webpack_require__(65300);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./components/PortfolioCommon/SelectorElement/styles.module.scss
var styles_module = __webpack_require__(26612);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/PortfolioCommon/SelectorElement/index.js





var SelectorElement = function(param) {
    var displayName = param.displayName, type = param.type, onClick = param.onClick, selected = param.selected, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        onClick: onClick,
        className: classnames_default()((styles_module_default()).selectorElement, (styles_module_default())[type], (0,_define_property/* default */.Z)({}, (styles_module_default()).selected, selected), className),
        children: displayName
    });
};
SelectorElement.defaultProps = {
    selected: null,
    className: ""
};
SelectorElement.propTypes = {
    displayName: (prop_types_default()).string.isRequired,
    type: (prop_types_default()).string.isRequired,
    onClick: (prop_types_default()).func.isRequired,
    selected: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var PortfolioCommon_SelectorElement = (SelectorElement);

;// CONCATENATED MODULE: ./components/PortfolioCommon/SelectorElement/utils/index.js
var SELECTOR_ELEMENT_TYPES = {
    typeSelector: "typeSelector",
    tagSelector: "tagSelector",
    tagDisplay: "tagDisplay"
};

// EXTERNAL MODULE: ./UI/containers/CustomSwiper/index.jsx + 2 modules
var CustomSwiper = __webpack_require__(33051);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
;// CONCATENATED MODULE: ./components/TypeSelector/utils/index.js

var SWIPER_PARAMS = {
    modules: [
        swiper_esm/* FreeMode */.Rv
    ],
    enabled: true,
    slidesPerView: "auto",
    spaceBetween: 16,
    passiveListeners: true,
    freeMode: {
        enabled: true,
        sticky: true
    },
    mousewheel: {
        forceToAxis: true
    },
    rewind: true,
    speed: 500
};

// EXTERNAL MODULE: ./components/TypeSelector/styles.module.scss
var TypeSelector_styles_module = __webpack_require__(89489);
var TypeSelector_styles_module_default = /*#__PURE__*/__webpack_require__.n(TypeSelector_styles_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/TypeSelector/utils/useTypeSelectorProps.js


var useTypeSelectorProps = function(_param) {
    var onSelectedTypeChange = _param.onSelectedTypeChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onSelectedTypeChange"
    ]);
    var handleTypeChange = function(type) {
        return function() {
            onSelectedTypeChange(type);
        };
    };
    return (0,_object_spread/* default */.Z)({
        handleTypeChange: handleTypeChange
    }, props);
};
/* harmony default export */ var utils_useTypeSelectorProps = (useTypeSelectorProps);

;// CONCATENATED MODULE: ./components/TypeSelector/index.jsx









function TypeSelector(props) {
    var ref = utils_useTypeSelectorProps(props), selectedType = ref.selectedType, handleTypeChange = ref.handleTypeChange, typeList = ref.typeList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSwiper["default"], {
        swiperParams: SWIPER_PARAMS,
        children: typeList.map(function(type) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                className: (TypeSelector_styles_module_default()).slide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioCommon_SelectorElement, {
                    type: SELECTOR_ELEMENT_TYPES.typeSelector,
                    displayName: type.displayName,
                    onClick: handleTypeChange(type),
                    selected: type === selectedType
                }, "WORK-TYPE/".concat(type.slug))
            }, type.displayName);
        })
    });
}
TypeSelector.propTypes = {
    selectedType: prop_types_default().shape({
        slug: (prop_types_default()).string.isRequired,
        displayName: (prop_types_default()).string.isRequired
    }).isRequired,
    onSelectedTypeChange: (prop_types_default()).func.isRequired
};
/* harmony default export */ var components_TypeSelector = (TypeSelector);

// EXTERNAL MODULE: ./components/BlogCommon/SelectionBlock/Categories/styles.module.scss
var Categories_styles_module = __webpack_require__(99860);
var Categories_styles_module_default = /*#__PURE__*/__webpack_require__.n(Categories_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/SelectionBlock/Categories/index.jsx








var Categories = function(param) {
    var isMobileCategoties = param.isMobileCategoties;
    var ref = (0,router.useRouter)(), asPath = ref.asPath, _query = ref.query, currentCategory = _query.slug, routerPush = ref.push;
    var categories = constants/* ROUTES.blog.categories.map */.y2.blog.categories.map(function(param) {
        var title = param.title, slug = param.slug;
        return {
            displayName: title,
            slug: slug
        };
    });
    var selectedCategory = !currentCategory || (0,helper/* isNumeric */.kE)(currentCategory) ? categories[0] : categories.slice(1).find(function(category) {
        return currentCategory.includes(category.slug);
    });
    (0,react.useEffect)(function() {
        (0,helper/* setOverflowForBody */.zd)(isMobileCategoties);
    }, [
        isMobileCategoties
    ]);
    var goToCategory = function(param) {
        var slug = param.slug;
        var path = constants/* ROUTES.blog.getRoute */.y2.blog.getRoute(slug).path;
        routerPush(path);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Categories_styles_module_default()).categories,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TypeSelector, {
            typeList: categories,
            selectedType: selectedCategory,
            onSelectedTypeChange: goToCategory
        })
    });
};
Categories.defaultProps = {
    isMobileCategoties: false
};
Categories.propTypes = {
    isMobileCategoties: (prop_types_default()).bool
};
/* harmony default export */ var SelectionBlock_Categories = (/*#__PURE__*/(0,react.memo)(Categories));

// EXTERNAL MODULE: ./components/BlogCommon/SelectionBlock/styles.module.scss
var SelectionBlock_styles_module = __webpack_require__(18195);
var SelectionBlock_styles_module_default = /*#__PURE__*/__webpack_require__.n(SelectionBlock_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/SelectionBlock/index.jsx












var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var SelectionBlock = function(param) {
    var toggleFullscreenSearch = param.toggleFullscreenSearch;
    var isMobileCategoties = (0,es.useSelector)(layout/* selectIsMobileCategotiesOpened */.qL);
    (0,react.useEffect)(function() {
        (0,helper/* setOverflowForBody */.zd)(isMobileCategoties);
    }, [
        isMobileCategoties
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((SelectionBlock_styles_module_default()).selectionBlock, (0,_define_property/* default */.Z)({}, (SelectionBlock_styles_module_default()).showCategories, isMobileCategoties)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectionBlock_Categories, {
                isMobileCategoties: isMobileCategoties
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SelectionBlock_styles_module_default()).buttons,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: constants/* SVG_IMAGES_TYPES.searchLg */.NL.searchLg,
                    handleOnClick: toggleFullscreenSearch,
                    className: (SelectionBlock_styles_module_default()).imgContainer
                })
            })
        ]
    });
};
SelectionBlock.defaultProps = {
    toggleFullscreenSearch: function() {
        return null;
    }
};
SelectionBlock.propTypes = {
    toggleFullscreenSearch: (prop_types_default()).func
};
/* harmony default export */ var BlogCommon_SelectionBlock = (SelectionBlock);

// EXTERNAL MODULE: ./components/BlogCommon/ArticlesList/index.jsx + 3 modules
var ArticlesList = __webpack_require__(63111);
// EXTERNAL MODULE: ./components/Common/MetaTags/index.jsx + 4 modules
var MetaTags = __webpack_require__(36003);
// EXTERNAL MODULE: ./UI/components/PageHeader/index.jsx
var PageHeader = __webpack_require__(2610);
// EXTERNAL MODULE: ./components/Layout/FullLayout/index.jsx
var FullLayout = __webpack_require__(22116);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./components/Common/ModalWindow/index.jsx
var ModalWindow = __webpack_require__(79897);
// EXTERNAL MODULE: ./redux/apis/blog.js + 2 modules
var blog = __webpack_require__(62736);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var chunk = __webpack_require__(8400);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);
// EXTERNAL MODULE: ./components/Common/ButtonMore/index.jsx
var ButtonMore = __webpack_require__(52039);
// EXTERNAL MODULE: ./components/BlogCommon/FullscreenSearch/SearchResult/styles.module.scss
var SearchResult_styles_module = __webpack_require__(56546);
var SearchResult_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchResult_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/FullscreenSearch/SearchResult/index.jsx










var SearchResult = function(param) {
    var foundArticles = param.foundArticles, isFetching = param.isFetching, handleOnCloseModalWindow = param.handleOnCloseModalWindow;
    var ref = (0,react.useState)([]), articlesChunks = ref[0], setArticlesChunks = ref[1];
    var ref1 = (0,react.useState)([]), articles = ref1[0], setArticles = ref1[1];
    var handleOnButtonClick = function() {
        var shiftedChunks = (0,_to_consumable_array/* default */.Z)(articlesChunks);
        var chunk = shiftedChunks.shift();
        setArticlesChunks(shiftedChunks);
        setArticles(function(prev) {
            return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(chunk));
        });
    };
    (0,react.useEffect)(function() {
        if (!foundArticles.length) {
            return;
        }
        var chunks = chunk_default()(foundArticles, 12);
        setArticlesChunks(chunks);
        setArticles(chunks.shift());
    }, [
        foundArticles
    ]);
    if (!articles.length && !isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (SearchResult_styles_module_default()).nothingFound,
            children: "Nothing Found. Please try again with some different keywords."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchResult_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesList/* ArticlesList */.f, {
                articles: articles,
                handleOnCloseModalWindow: handleOnCloseModalWindow,
                isSearch: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMore/* default */.Z, {
                title: "Load more",
                buttonStyle: classnames_default()((SearchResult_styles_module_default()).button, (0,_define_property/* default */.Z)({}, (SearchResult_styles_module_default()).hideButton, foundArticles.length === articles.length)),
                handleOnClick: handleOnButtonClick
            })
        ]
    });
};
SearchResult.propTypes = {
    foundArticles: prop_types_default().arrayOf(Object).isRequired,
    isFetching: (prop_types_default()).bool.isRequired,
    handleOnCloseModalWindow: (prop_types_default()).func.isRequired
};
/* harmony default export */ var FullscreenSearch_SearchResult = (SearchResult);

// EXTERNAL MODULE: ./components/BlogCommon/FullscreenSearch/styles.module.scss
var FullscreenSearch_styles_module = __webpack_require__(60588);
var FullscreenSearch_styles_module_default = /*#__PURE__*/__webpack_require__.n(FullscreenSearch_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/FullscreenSearch/index.jsx








var FullscreenSearch = function(param) {
    var isFullscreenSearch = param.isFullscreenSearch, closeFullscreenSearch = param.closeFullscreenSearch;
    var inputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(""), inputValue = ref[0], setInputValue = ref[1];
    var ref1 = (0,react.useState)(inputValue), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,blog/* useGetSearchResultQuery */.i1)(searchTerm), tmp = ref2.data, articles = tmp === void 0 ? [] : tmp, isFetching = ref2.isFetching;
    var delayedQuery = (0,react.useMemo)(function() {
        return debounce_default()(function(value) {
            return setSearchTerm(value);
        }, 1000);
    }, []);
    var handleOnChangeInput = function(param) {
        var value = param.target.value;
        setInputValue(value);
        delayedQuery(value);
    };
    var handleOnCloseModalWindow = function() {
        closeFullscreenSearch();
        setInputValue("");
        setSearchTerm("");
    };
    (0,react.useEffect)(function() {
        if (isFullscreenSearch && inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [
        isFullscreenSearch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWindow/* default */.Z, {
        isModalWindow: isFullscreenSearch,
        closeModalWindow: handleOnCloseModalWindow,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FullscreenSearch_styles_module_default()).foundArticles,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    ref: inputRef,
                    className: (FullscreenSearch_styles_module_default()).input,
                    type: "text",
                    placeholder: "Type to search",
                    onChange: handleOnChangeInput,
                    value: inputValue
                }),
                searchTerm.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenSearch_SearchResult, {
                    foundArticles: articles,
                    isFetching: isFetching,
                    handleOnCloseModalWindow: handleOnCloseModalWindow
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (FullscreenSearch_styles_module_default()).nothingFound,
                    children: "Type some words to search."
                })
            ]
        })
    });
};
FullscreenSearch.defaultProps = {
    isFullscreenSearch: false
};
FullscreenSearch.propTypes = {
    isFullscreenSearch: (prop_types_default()).bool,
    closeFullscreenSearch: (prop_types_default()).func.isRequired
};
/* harmony default export */ var BlogCommon_FullscreenSearch = (/*#__PURE__*/(0,react.memo)(FullscreenSearch));

// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
// EXTERNAL MODULE: ./redux/apis/page.js
var page = __webpack_require__(85144);
// EXTERNAL MODULE: ./node_modules/react-outside-click-handler/index.js
var react_outside_click_handler = __webpack_require__(39834);
// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.esm.js
var autosize_esm = __webpack_require__(3682);
// EXTERNAL MODULE: ./components/Common/AnimatedInput/styles.module.scss
var AnimatedInput_styles_module = __webpack_require__(37612);
var AnimatedInput_styles_module_default = /*#__PURE__*/__webpack_require__.n(AnimatedInput_styles_module);
;// CONCATENATED MODULE: ./components/Common/AnimatedInput/index.jsx












var AnimatedInput = function(param) {
    var value = param.value, handleOnChange = param.handleOnChange, placeholder = param.placeholder, type = param.type, handleOnBlurEmail = param.handleOnBlurEmail, isWithoutLabel = param.isWithoutLabel, isRequired = param.isRequired, isValidate = param.isValidate, isAttached = param.isAttached, isTextArea = param.isTextArea, style = param.style;
    var asPath = (0,router.useRouter)().asPath;
    var inputRef = (0,react.useRef)();
    var ref = (0,react.useState)(false), isInputActived = ref[0], setActive = ref[1];
    var ref1 = (0,react.useState)(false), isInputFocus = ref1[0], setFocus = ref1[1];
    var _obj;
    var animatedInput = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default())[style], style), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).animatedInput, true), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).isRequired, isRequired || isAttached), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).isValidate, !isValidate), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).active, isInputActived), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).focus, isInputFocus && isValidate), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).error, !isValidate && value !== ""), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default())["default"], !isInputFocus && isValidate && value !== ""), _obj));
    var handleOnClick = function() {
        inputRef.current.focus();
        setActive(true);
    };
    var handleOnFocus = function() {
        setFocus(true);
    };
    var handleOnBlur = function() {
        setFocus(false);
        setActive(false);
        if (type === "email" && value !== "" && handleOnBlurEmail) {
            handleOnBlurEmail(value);
        }
    };
    var handleOnOutsideClick = function() {
        value === "" && setActive(false);
    };
    var inputOptions = {
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        ref: inputRef,
        placeholder: isWithoutLabel && placeholder,
        type: "text",
        id: value,
        value: value,
        onChange: handleOnChange,
        autoFocus: asPath === constants/* ROUTES.contact.path */.y2.contact.path && placeholder.includes("Name")
    };
    (0,react.useEffect)(function() {
        if (isTextArea && inputRef && inputRef.current) {
            (0,autosize_esm/* default */.Z)(inputRef.current);
        }
    }, [
        isTextArea
    ]);
    // the removing the textarea height when clearing form
    (0,react.useEffect)(function() {
        if (isTextArea && inputRef && inputRef.current && value === "") {
            if (inputRef.current.style.height !== "auto") {
                inputRef.current.style.height = "auto";
            }
        }
    }, [
        value,
        isTextArea
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_outside_click_handler["default"], {
        onOutsideClick: handleOnOutsideClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: animatedInput,
            onClick: handleOnClick,
            role: "textbox",
            tabIndex: "0",
            children: [
                !isWithoutLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: value,
                    children: placeholder
                }),
                isTextArea ? /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputOptions), {
                    rows: 1
                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({}, inputOptions)),
                isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (AnimatedInput_styles_module_default()).required,
                    children: "*"
                }),
                !isValidate && value !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (AnimatedInput_styles_module_default()).invalid,
                    children: "INVALID"
                })
            ]
        })
    });
};
AnimatedInput.defaultProps = {
    isWithoutLabel: false,
    handleOnBlurEmail: null,
    type: "",
    isRequired: false,
    isAttached: false,
    isTextArea: false,
    style: ""
};
AnimatedInput.propTypes = {
    value: (prop_types_default()).string.isRequired,
    handleOnChange: (prop_types_default()).func.isRequired,
    placeholder: (prop_types_default()).string.isRequired,
    isValidate: (prop_types_default()).bool.isRequired,
    type: (prop_types_default()).string,
    handleOnBlurEmail: (prop_types_default()).func,
    isWithoutLabel: (prop_types_default()).bool,
    isRequired: (prop_types_default()).bool,
    isAttached: (prop_types_default()).bool,
    isTextArea: (prop_types_default()).bool,
    style: (prop_types_default()).string
};
/* harmony default export */ var Common_AnimatedInput = (AnimatedInput);

// EXTERNAL MODULE: ./hocs/withValidateEmail.js
var withValidateEmail = __webpack_require__(54639);
// EXTERNAL MODULE: ./components/BlogCommon/FullscreenSubscribe/styles.module.scss
var FullscreenSubscribe_styles_module = __webpack_require__(47789);
var FullscreenSubscribe_styles_module_default = /*#__PURE__*/__webpack_require__.n(FullscreenSubscribe_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/FullscreenSubscribe/index.jsx









var FullscreenSubscribe = function(param) {
    var isFullscreenSubscribe = param.isFullscreenSubscribe, closeFullscreenSubscribe = param.closeFullscreenSubscribe, email = param.email, handleOnEmailChange = param.handleOnEmailChange, handleOnBlurEmail = param.handleOnBlurEmail, handleOnSubmit = param.handleOnSubmit;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), _ = ref[0], ref1 = ref[1], tmp = ref1.data, ref2 = tmp === void 0 ? {} : tmp, message = ref2.message, newUser = ref2.newUser;
    var handleOnClick = function(event) {
        event.preventDefault();
        handleOnSubmit(email.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWindow/* default */.Z, {
        isModalWindow: isFullscreenSubscribe,
        closeModalWindow: closeFullscreenSubscribe,
        className: (FullscreenSubscribe_styles_module_default()).fullscreenSubscribe,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (FullscreenSubscribe_styles_module_default()).subscribeBlock,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FullscreenSubscribe_styles_module_default()).subscribe,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FullscreenSubscribe_styles_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (FullscreenSubscribe_styles_module_default()).title,
                            children: "Join for weekly insights"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (FullscreenSubscribe_styles_module_default()).subtitle,
                            children: "Get weekly updates on the newest design stories, case studies and tips right in your mailbox."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FullscreenSubscribe_styles_module_default()).inputBlock,
                            children: [
                                newUser || /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_AnimatedInput, {
                                    value: email.value,
                                    handleOnChange: handleOnEmailChange,
                                    placeholder: "Email*",
                                    isWithoutLabel: true,
                                    type: "email",
                                    isValidate: email.isValidate,
                                    handleOnBlurEmail: handleOnBlurEmail
                                }),
                                message && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (FullscreenSubscribe_styles_module_default()).alertMessage,
                                    children: message
                                }),
                                newUser || /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMore/* default */.Z, {
                                    title: "Subscribe",
                                    buttonStyle: (FullscreenSubscribe_styles_module_default()).button,
                                    handleOnClick: handleOnClick
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
FullscreenSubscribe.defaultProps = {
    isFullscreenSubscribe: false,
    handleOnSubmit: function() {}
};
FullscreenSubscribe.propTypes = {
    isFullscreenSubscribe: (prop_types_default()).bool,
    closeFullscreenSubscribe: (prop_types_default()).func.isRequired,
    email: prop_types_default().instanceOf(Object).isRequired,
    handleOnEmailChange: (prop_types_default()).func.isRequired,
    handleOnBlurEmail: (prop_types_default()).func.isRequired,
    handleOnSubmit: (prop_types_default()).func
};
/* harmony default export */ var BlogCommon_FullscreenSubscribe = ((0,withValidateEmail/* withValidateEmail */.l)(FullscreenSubscribe));

// EXTERNAL MODULE: ./utils/breadcrumbs.js
var utils_breadcrumbs = __webpack_require__(84047);
// EXTERNAL MODULE: ./hooks/useToggle.js
var useToggle = __webpack_require__(90981);
;// CONCATENATED MODULE: ./UI/views/Blog/utils/data.js
var categoriesMetaData = {
    "how-we-work": {
        metaTitle: "Tag: How we work | Yellow",
        metaDescription: "Read about our most successful projects. The Yellow team reveals its tips and tricks on their blog!",
        pageTitle: "How we work"
    },
    "software-development": {
        metaTitle: "Tag: Software Development | Yellow",
        metaDescription: "In this section, we bring you the latest software development news and insights. Don't miss reading!",
        pageTitle: "Software Development"
    },
    "software-chat": {
        metaTitle: "Tag: Software Chat | Yellow",
        metaDescription: "The Yellow team will reveal to you all the secrets of software chat development: detailed case studies, lists, guides.",
        pageTitle: "Software Chat"
    },
    fintech: {
        metaTitle: "Tag: Fintech | Yellow",
        metaDescription: "In this section, we will discuss the best practices of fintech development.\n    Lending platforms, trading services, e-wallets, budgeting apps, and more.",
        pageTitle: "Fintech"
    },
    yellow: {
        metaTitle: "Tag: Yellow  | Yellow Blog",
        metaDescription: "The latest news and achievements of the Yellow team. We share information about our company and its processes.",
        pageTitle: "Yellow"
    }
};

;// CONCATENATED MODULE: ./UI/views/Blog/utils/blogContainerHelper.js
var findTagBySlug = function(tagsList, slug) {
    return tagsList === null || tagsList === void 0 ? void 0 : tagsList.find(function(tag) {
        return tag.slug === slug;
    });
};
var findCategoryBySlug = function(categories, slug) {
    return categories[slug];
};

// EXTERNAL MODULE: ./UI/views/Blog/BlogContainer.module.scss
var BlogContainer_module = __webpack_require__(3821);
var BlogContainer_module_default = /*#__PURE__*/__webpack_require__.n(BlogContainer_module);
;// CONCATENATED MODULE: ./UI/views/Blog/index.jsx

























var Blog_Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var BlogContainer = function(param) {
    var tagsList = param.tagsList, introSection = param.introSection, currentPage = param.currentPage, articlesNumberPerPage = param.articlesNumberPerPage, query = param.query;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), subscribe = ref[0], isLoading = ref[1].isLoading;
    var ref1 = (0,page/* useFetchPageQuery */.o)(constants/* PAGES.blog */.q5.blog), tmp = ref1.data, metaData = (tmp === void 0 ? {} : tmp).metaData;
    var ref2 = (0,blog/* useGetArticlesListQuery */.rh)(query), _data = ref2.data, data = _data === void 0 ? {} : _data;
    var articles = data.items, totalArticles = data.total;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isFullscreenSearch = ref3[0], toggleFullscreenSearch = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isFullscreenSubscribe = ref4[0], toggleFullscreenSubscribe = ref4[1];
    var ref5 = (0,router.useRouter)(), pathname = ref5.pathname, slug = ref5.query.slug;
    var tag = findTagBySlug(tagsList, slug);
    var category = findCategoryBySlug(categoriesMetaData, slug);
    var pagesCounter = Math.ceil(totalArticles / articlesNumberPerPage);
    var breadcrumbs = (0,utils_breadcrumbs/* getBreadcrumbs */.Z)(constants/* PAGES.blog */.q5.blog, {
        slug: slug,
        tagsList: tagsList
    });
    var pageMetadata = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, metaData), {
        url: "".concat(helper/* rootUrl */.Wd, "/").concat(constants/* PAGES.blog */.q5.blog),
        pageNumber: currentPage
    });
    if (tag || category) {
        pageMetadata.metaRobots = "noindex,follow";
    }
    var pageTitle = "";
    if (category) {
        var categoryMetaTitle = category.metaTitle, categoryMetaDescription = category.metaDescription, categoryTitle = category.pageTitle;
        pageMetadata.metaTitle = categoryMetaTitle;
        pageMetadata.metaDescription = categoryMetaDescription;
        pageTitle = categoryTitle;
    }
    if (tag) {
        var tagTitle = tag.title, tagDescription = tag.description;
        pageMetadata.metaTitle = "Tag: ".concat(tagTitle, " | Yellow");
        pageMetadata.metaDescription = tagDescription;
        pageTitle = tagTitle;
    }
    var handleOnFormSubmit = function(email) {
        if (isLoading) {
            return;
        }
        subscribe({
            email: email,
            pathname: pathname
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: constants/* PAGES.blog */.q5.blog,
                pageMetadata: pageMetadata,
                breadcrumbs: breadcrumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullLayout/* default */.Z, {
                introSection: introSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        title: pageTitle || constants/* ROUTES.blog.title */.y2.blog.title,
                        titleStyles: (BlogContainer_module_default()).title,
                        breadcrumbs: breadcrumbs,
                        breadcrumbsTheme: "dark",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_Svg, {
                            type: constants/* SVG_IMAGES_TYPES.searchLg */.NL.searchLg,
                            handleOnClick: toggleFullscreenSearch,
                            className: (BlogContainer_module_default()).searchButton
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCommon_SelectionBlock, {
                        toggleFullscreenSearch: toggleFullscreenSearch,
                        toggleFullscreenSubscribe: toggleFullscreenSubscribe
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesList/* default */.Z, {
                        articles: articles,
                        isBlogPage: true,
                        currentPage: currentPage,
                        toggleFullscreenSubscribe: toggleFullscreenSubscribe
                    }),
                    !!pagesCounter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paginator/* default */.Z, {
                        pagesCounter: pagesCounter,
                        currentPage: currentPage,
                        pageSlug: constants/* ROUTES.blog.slug */.y2.blog.slug
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCommon_FullscreenSearch, {
                isFullscreenSearch: isFullscreenSearch,
                closeFullscreenSearch: toggleFullscreenSearch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCommon_FullscreenSubscribe, {
                isFullscreenSubscribe: isFullscreenSubscribe,
                closeFullscreenSubscribe: toggleFullscreenSubscribe,
                handleOnSubmit: handleOnFormSubmit
            })
        ]
    });
};
BlogContainer.propTypes = {
    introSection: prop_types_default().instanceOf(Object).isRequired,
    currentPage: (prop_types_default()).number.isRequired,
    articlesNumberPerPage: (prop_types_default()).number.isRequired
};
/* harmony default export */ var Blog = (BlogContainer);


/***/ }),

/***/ 52039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40659);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48333);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var ButtonMore = function(_param) {
    var href = _param.href, dynamicRouting = _param.dynamicRouting, title = _param.title, buttonStyle = _param.buttonStyle, handleOnClick = _param.handleOnClick, buttonRef = _param.buttonRef, isDisabled = _param.isDisabled, disabledButtonStyle = _param.disabledButtonStyle, type = _param.type, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "href",
        "dynamicRouting",
        "title",
        "buttonStyle",
        "handleOnClick",
        "buttonRef",
        "isDisabled",
        "disabledButtonStyle",
        "type"
    ]);
    return !href.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: buttonRef,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonStyle, buttonStyle)),
        onClick: handleOnClick,
        role: "button",
        tabIndex: "0"
    }, rest), {
        children: title
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        isLocalLink: true,
        path: href,
        dynamicRouting: dynamicRouting,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().link), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[type], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, disabledButtonStyle, isDisabled))
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonStyle, buttonStyle)),
            onClick: handleOnClick,
            role: "button",
            tabIndex: "0",
            children: title
        })
    }));
};
ButtonMore.defaultProps = {
    href: "",
    dynamicRouting: "",
    buttonStyle: null,
    type: "",
    buttonRef: null,
    handleOnClick: null,
    isDisabled: false,
    disabledButtonStyle: null
};
ButtonMore.propTypes = {
    href: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    dynamicRouting: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
        prop_types__WEBPACK_IMPORTED_MODULE_8___default().instanceOf(Object), 
    ]),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
    buttonStyle: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    handleOnClick: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func),
    buttonRef: prop_types__WEBPACK_IMPORTED_MODULE_8___default().instanceOf(Object),
    isDisabled: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    disabledButtonStyle: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonMore);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 79897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86324);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);









var Svg = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var ModalWindow = function(param) {
    var isModalWindow = param.isModalWindow, closeModalWindow = param.closeModalWindow, children = param.children, className = param.className;
    var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleOnClick = function(param) {
        var target = param.target;
        if (modalRef && modalRef.current) {
            if (modalRef.current.isEqualNode(target)) closeModalWindow();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .setOverflowForBody */ .zd)(isModalWindow);
    }, [
        isModalWindow
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleOnKeyDown = function(param) {
            var key = param.key;
            if (key === "Escape") {
                closeModalWindow();
            }
        };
        document.addEventListener("keydown", handleOnKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleOnKeyDown);
        };
    }, [
        closeModalWindow
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalWindowContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().show), isModalWindow)),
        onClick: handleOnClick,
        ref: modalRef,
        role: "dialog",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalWindow), className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Svg, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().svg),
                    type: utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SVG_IMAGES_TYPES.closeSvg */ .NL.closeSvg,
                    handleOnClick: closeModalWindow
                }),
                children
            ]
        })
    });
};
ModalWindow.defaultProps = {
    className: ""
};
ModalWindow.propTypes = {
    isModalWindow: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool.isRequired),
    closeModalWindow: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func.isRequired),
    children: prop_types__WEBPACK_IMPORTED_MODULE_8___default().instanceOf(Object).isRequired,
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalWindow);


/***/ }),

/***/ 22116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(321);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);





var FullLayout = function(param) {
    var children = param.children, disableMaxWidth = param.disableMaxWidth, disableTopPadding = param.disableTopPadding, disableSidePadding = param.disableSidePadding, disableBottomPadding = param.disableBottomPadding, disableOverflowHiding = param.disableOverflowHiding, backgroundColor = param.backgroundColor, introSection = param.introSection, className = param.className;
    var _obj;
    var layoutStyles = classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullLayout), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[backgroundColor], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableMaxWidth), disableMaxWidth), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableTopPadding), disableTopPadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableSidePadding), disableSidePadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableBottomPadding), disableBottomPadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableOverflowHiding), disableOverflowHiding), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: layoutStyles,
        ref: introSection,
        children: children
    });
};
FullLayout.defaultProps = {
    children: {},
    disableMaxWidth: false,
    disableTopPadding: false,
    disableSidePadding: false,
    disableBottomPadding: false,
    backgroundColor: "",
    introSection: null
};
FullLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object),
    disableMaxWidth: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableTopPadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableSidePadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableBottomPadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    backgroundColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    introSection: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["Z"] = (FullLayout);


/***/ }),

/***/ 54639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ withValidateEmail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6572);




var withValidateEmail = function(Component) {
    return function(props) {
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
            value: "",
            isValidate: true
        }), email = ref[0], setEmail = ref[1];
        var handleOnEmailChange = function(param) {
            var value = param.target.value;
            setEmail({
                value: value,
                isValidate: true
            });
        };
        var handleOnBlurEmail = function(value) {
            setEmail({
                value: value,
                isValidate: (0,utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .validateEmail */ .oH)(value)
            });
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            email: email,
            handleOnEmailChange: handleOnEmailChange,
            handleOnBlurEmail: handleOnBlurEmail
        }, props));
    };
};


/***/ }),

/***/ 90981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var reducer = function(stateHandler) {
    return function(state) {
        if (typeof stateHandler === "function") {
            stateHandler(!state);
        }
        return !state;
    };
};
function useToggle(initialState, stateHandler) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer(stateHandler), !!initialState), isEnabled = ref[0], toggle = ref[1];
    return [
        isEnabled,
        toggle
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 85144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useFetchPageQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91555);




var pageApi = ___WEBPACK_IMPORTED_MODULE_0__["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            fetchPage: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.getEntries
                },
                query: function(slug) {
                    return {
                        contentType: "page",
                        additionalQueryParams: {
                            "fields.slug": slug
                        }
                    };
                },
                transformResponse: function transformResponse(response, _, arg) {
                    if (!arg || typeof arg !== "string") {
                        return {
                            data: {}
                        };
                    }
                    var data = response.items[0].fields;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, data), {
                        metaData: {
                            metaTitle: data.metaTitle || "",
                            metaDescription: data.metaDescription || "",
                            metaRobots: data.metaRobots || "",
                            ogImage: (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getFileUrl */ .qm)(data.ogImage)
                        }
                    });
                }
            })
        };
    }
});
var useFetchPageQuery = pageApi.useFetchPageQuery;
/* harmony default export */ __webpack_exports__["Z"] = (pageApi);


/***/ }),

/***/ 84047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);


function getBreadcrumbs(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, title = ref.title, slug = ref.slug, tagsList = ref.tagsList;
    var currentRoute = Object.values(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES */ .y2).find(function(route) {
        return route.slug === page;
    });
    var breadcrumbs = [
        {
            to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.path */ .y2.homepage.path,
            title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.title */ .y2.homepage.title
        }, 
    ];
    switch(currentRoute.slug){
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.slug */ .y2.blog.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (slug && !(0,utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isNumeric */ .kE)(slug)) {
                var tag = tagsList === null || tagsList === void 0 ? void 0 : tagsList.find(function(param) {
                    var tagSlug = param.slug;
                    return tagSlug === slug;
                });
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.getRoute */ .y2.blog.getRoute(slug).path,
                    title: tag === null || tag === void 0 ? void 0 : tag.title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.slug */ .y2.project.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.path */ .y2.portfolio.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.title */ .y2.portfolio.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.getRoute */ .y2.project.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.slug */ .y2.article.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.getRoute */ .y2.article.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.slug */ .y2.person.slug:
            breadcrumbs.splice(0, 1);
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.getRoute */ .y2.person.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        default:
            breadcrumbs.push({
                to: currentRoute.path,
                title: currentRoute.title
            });
            return breadcrumbs;
    }
}


/***/ }),

/***/ 51701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__U7jAD","item":"styles_item__WAV19","activeItem":"styles_activeItem__Sdvlz","dark":"styles_dark__9MzT_"};

/***/ }),

/***/ 42222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"styles_titleContainer__EQ1kE","updatedAt":"styles_updatedAt__pww8i"};

/***/ }),

/***/ 5713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navButton":"styles_navButton___E8aQ","text":"styles_text__fy5hq","next":"styles_next__89xlm"};

/***/ }),

/***/ 35133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigationContainer":"styles_navigationContainer__cgD9j"};

/***/ }),

/***/ 3821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"BlogContainer_title__pSut_","searchButton":"BlogContainer_searchButton__lFuev"};

/***/ }),

/***/ 56546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nothingFound":"styles_nothingFound__Koocr","container":"styles_container__qh8Eo","button":"styles_button__Ji1Q_","hideButton":"styles_hideButton__bRxX5"};

/***/ }),

/***/ 60588:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"foundArticles":"styles_foundArticles__m4XQE","input":"styles_input__LAuLb","nothingFound":"styles_nothingFound__pzrQ_"};

/***/ }),

/***/ 47789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullscreenSubscribe":"styles_fullscreenSubscribe__W1acR","subscribeBlock":"styles_subscribeBlock__Rjrio","subscribe":"styles_subscribe__hgcUO","content":"styles_content__ICcI5","title":"styles_title__WY2C_","subtitle":"styles_subtitle__xrXGI","inputBlock":"styles_inputBlock__1Ravz","button":"styles_button__UHEFO"};

/***/ }),

/***/ 99860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categories":"styles_categories__0rr28","selectedBlock":"styles_selectedBlock__fqBUq"};

/***/ }),

/***/ 18195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectionBlock":"styles_selectionBlock__z9Pya","buttons":"styles_buttons__JgV5H","imgContainer":"styles_imgContainer__RLohM","showCategories":"styles_showCategories__3kAgr"};

/***/ }),

/***/ 37612:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animatedInput":"styles_animatedInput__dkzWe","required":"styles_required__niI4c","invalid":"styles_invalid__3htvm","active":"styles_active__3ODrq","focus":"styles_focus__pqxmp","error":"styles_error__DObs8","default":"styles_default__H1PCb","isRequired":"styles_isRequired__c4zue","isValidate":"styles_isValidate__fMuzW","seven-pm-thursday":"styles_seven-pm-thursday__sa0JX","open-sense":"styles_open-sense__UAjOY"};

/***/ }),

/***/ 48333:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__copVk","home":"styles_home__QWxgR"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ }),

/***/ 86324:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWindowContainer":"styles_modalWindowContainer__ob2Fw","modalWindow":"styles_modalWindow__y6P7Y","svg":"styles_svg__i9wAY","show":"styles_show__3kdTG"};

/***/ }),

/***/ 321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullLayout":"styles_fullLayout__pin3O","disableOverflowHiding":"styles_disableOverflowHiding__LcGJo","disableMaxWidth":"styles_disableMaxWidth__V_d1K","disableSidePadding":"styles_disableSidePadding__Ybgq_","disableTopPadding":"styles_disableTopPadding__PX_CS","disableBottomPadding":"styles_disableBottomPadding__8xmaX","alabaster":"styles_alabaster__keXtu"};

/***/ }),

/***/ 26612:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectorElement":"styles_selectorElement__TMAlS","typeSelector":"styles_typeSelector__y49R5","selected":"styles_selected__Bvdse","tagSelector":"styles_tagSelector__SwIti","tagDisplay":"styles_tagDisplay__S0P23"};

/***/ }),

/***/ 89489:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slide":"styles_slide__6qKOd"};

/***/ })

}]);